var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useJudoPay } from './useJudoPay';
import { forwardRef, useEffect, useImperativeHandle } from 'react';
import { createCustomerTransactionAction, updateCustomerTransactionAction, useApi, } from '@getclarauk/api-client';
import { getInternationalPhoneNumber } from '../components/CountryDiallingCodeField';
export var JudoPayCardForm = forwardRef(function (_a, ref) {
    var provider = _a.provider;
    var judo = useJudoPay(provider.apiKey, provider.sandbox);
    var createCustomerTransaction = useApi(createCustomerTransactionAction)[0];
    var updateCustomerTransaction = useApi(updateCustomerTransactionAction)[0];
    useEffect(function () {
        if (!judo)
            return;
        judo.createCardDetails('judopay-payment-iframe', {
            iframe: {
                layout: 'compact',
                isCardHolderNameVisible: false,
            },
        });
    }, [judo]);
    useImperativeHandle(ref, function () {
        return {
            capture: function (options) {
                return __awaiter(this, void 0, void 0, function () {
                    var transaction, session, invoke, phone, result, err_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!judo)
                                    return [2 /*return*/, {}];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 5, , 6]);
                                return [4 /*yield*/, createCustomerTransaction({
                                        userId: options.userId,
                                        amount: options.amount,
                                        description: options.description,
                                        itemType: options.itemType,
                                        itemId: options.itemId,
                                        pharmacyId: options.pharmacyId,
                                        cardholderName: options.givenName + ' ' + options.familyName,
                                        moto: options.moto,
                                        email: options.email,
                                    })];
                            case 2:
                                transaction = _a.sent();
                                session = transaction === null || transaction === void 0 ? void 0 : transaction.session;
                                if (!transaction || !(session === null || session === void 0 ? void 0 : session.judo)) {
                                    return [2 /*return*/, { error: 'Error' }];
                                }
                                invoke = options.moto ? judo.invokePayment : judo.invokePreauth;
                                phone = getInternationalPhoneNumber(options.phone);
                                return [4 /*yield*/, invoke(session.judo.sessionId, __assign({ judoId: session.judo.judoId, amount: options.amount / 100, currency: 'GBP', yourConsumerReference: session.judo.consumerId, yourPaymentReference: session.judo.paymentId, billingAddress: options.address && {
                                            address1: options.address.line1,
                                            address2: options.address.line2 || '',
                                            town: options.address.town,
                                            postcode: options.address.postcode,
                                            countryCode: 826,
                                        }, emailAddress: options.email || undefined }, (phone.number
                                        ? {
                                            mobileNumber: phone.number,
                                            phoneCountryCode: phone.code,
                                        }
                                        : {})))];
                            case 3:
                                result = _a.sent();
                                if ((result === null || result === void 0 ? void 0 : result.result) === 'ERROR' || !(result === null || result === void 0 ? void 0 : result.receiptId)) {
                                    return [2 /*return*/, { error: 'Error' }];
                                }
                                return [4 /*yield*/, updateCustomerTransaction({
                                        _id: transaction._id,
                                        providerTransactionId: result.receiptId,
                                    })];
                            case 4:
                                _a.sent();
                                return [2 /*return*/, { customerTransactionId: transaction._id }];
                            case 5:
                                err_1 = _a.sent();
                                return [2 /*return*/, { error: err_1.message }];
                            case 6: return [2 /*return*/];
                        }
                    });
                });
            },
        };
    });
    return jsx("div", { id: "judopay-payment-iframe", sx: { width: '320px' } });
});
//# sourceMappingURL=JudoPayCardForm.js.map